import { ReactNode } from 'react';

import { Text } from '../../../cdl/Text/Text';
import { Box } from '../../ui/Box';
import { Required } from '../Required/Required';
import { Label as StyledLabel } from '../TextInput/Input';

interface LabelProps {
    label?: string;
    annotation?: string;
    required?: boolean;
    children: ReactNode;
}
/**
 * @deprecated use LabelText from the common folder instead
 **/
export const Label = ({ label, annotation, children, required }: LabelProps) => {
    if (!label) {
        return <Box position="relative">{children}</Box>;
    }

    return (
        <StyledLabel>
            <Box display="flex" paddingX={8} paddingY={8} justifyContent="space-between">
                <Text size={12}>
                    {label}
                    {required ? <Required /> : null}
                </Text>
                {annotation ? <Text size={12}>{annotation}</Text> : null}
            </Box>

            {children}
        </StyledLabel>
    );
};
